import { useCaptainEnabled } from "../hooks/useCaptainEnabled";
import {
  toggleCaptain,
  useCaptainPanel,
} from "../hooks/useCaptainPanel";

export function CaptainChatButton() {
  const enabled = useCaptainEnabled();
  const { isOpen } = useCaptainPanel();

  if (!enabled || isOpen) return null;

  return (
    <button
      onClick={toggleCaptain}
      className="fixed bottom-4 right-4 z-40 size-[72px] cursor-pointer overflow-hidden rounded-full border-[4px] border-neutral-600 bg-muted shadow-lg transition-transform hover:scale-105"
    >
      <img
        src="/assets/captain/avatar.png"
        alt="Open Captain"
        className="mt-2 size-full scale-110 object-cover"
      />
    </button>
  );
}
